
const Article = (props) => {

  // const [isHover, setIsHover] = useState(false)

  // const handleMouseEnter = () => {
  //   setIsHover(true)
  // }

  // const handleMouseLeave = () => {
  //   setIsHover(false)
  // }

  const url = {
    backgroundImage: props.urlBackground,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
  }

  return <a className="flex flex-col max-w-2/4 sm:w-2/5 2sm:max-w-articleXS justify-start text-darkblue font-bold text-md lg:text-xl xl:text-xl hover:text-orange transition-all duration-250" href={props.href} rel="noreferrer">
    <div className='placeholder h-80 2sm:w-full 2sm:h-56 max-w rounded-md transition-all duration-500 cursor-pointer' style={url}/>
    <p className='description mt-2 w-full max-w-80 2sm:w-full'>{props.content}</p>
  </a>
}

export default Article